<template>
  <vx-card no-shadow>

    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vx-form layout="v" class="md:w-1/2">
        <form-item class="mt-5" label="头像">
          <upload
            fileName="file"
            v-model="form.avatarUrl"
            data-vv-name="installer"
            automatic
            text="上传"
            accept=".jpg,.png"
            action="/admin/v1/file/upload"
            :single-upload="true"
            :limit="1"
          />
        </form-item>
        <form-item class="mt-5" label="昵称">
          <vs-input class="w-full" placeholder="请输入昵称" v-model="form.nickName" />
        </form-item>
        <form-item class="mt-5" label="性别" label-align="none" >
        <vs-radio v-model="form.sex" vs-name="sex" vs-value="1">男</vs-radio>
        <vs-radio v-model="form.sex" vs-name="sex" vs-value="2">女</vs-radio>
      </form-item>
        <form-item required class="mt-5" label="邮箱">
          <vs-input class="w-full" placeholder="请输入邮箱" v-model="form.email" />
        </form-item>
        <form-item class="mt-5" label="手机号">
          <vs-input class="w-full" placeholder="请输入手机号" v-model="form.phone" />
        </form-item>
        <form-item class="mt-5" label="生日">
          <date-picker v-model="form.birthday" />
        </form-item>
        <form-item label="地址" class="w-full mt-5">
          <vs-input class="w-32 inline-block mr-1 mb-1" placeholder="国家" v-model="form.country" />
          <vs-input class="w-32 inline-block mr-1 mb-1" placeholder="省份" v-model="form.province" />
          <vs-input class="w-32 inline-block mr-1 mb-1" placeholder="城市" v-model="form.city" />
          <vs-input class="w-auto inline-block mr-1 mb-1" placeholder="地址" v-model="form.address" />
        </form-item>
        <form-item>
          <vs-button class="mr-3 mb-2" @click="submitForm">保存设置</vs-button>
        </form-item>
      </vx-form>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      form: {}
    }
  },
  mounted() {
    const user = this.$s.auth.user
    this.form = {
      ...user,
      birthday: new Date(user.birthday),
    }
  },
  methods: {
    async submitForm() {
      
      const preuser = {
        ...this.form,
        sex: Number(this.form.sex) || 0,
      }

      const user = await this.$s.user.updateSelf(preuser)
      this.$s.auth.user = preuser
      this.$notify({
        title: '保存成功',
        text: '您的个人资料更新成功'
      })

    }
  }
}
</script>
